import { Helper } from "./helpers/helper";
import { ImisAuthentication as Authentication, ImisMessageType as MessageType, ImisPayloadFieldType as PayloadFieldType } from "./models/imis.models";
import { ContextUtility } from "./utilities/context.utility";
import { DataSourcesUtility } from "./utilities/dataSources.utility";
import { FilesUtility } from "./utilities/file.utility";
import * as FormsUtility from "./utilities/forms.utility";
import { GenTablesUtility } from "./utilities/genTables.utility";
import * as HtmlUtility from "./utilities/html.utility";
import { LoaderUtility } from "./utilities/loader.utility";
import { MessagesUtility } from "./utilities/messages.utility";
import { PanelsUtility } from "./utilities/panels.utility";
import { PayloadUtility } from "./utilities/payload.utility";
import { RestUtility } from "./utilities/rest.utility";
import { UrlUtility } from "./utilities/url.utility";
import { WebFormsUtility } from "./utilities/webForms.utility";
import "./models/declarations/telerik.web.ui";
import { ChangeLogUtility } from "./utilities/changeLog.utility";
import { iPartUtility } from "./utilities/iPart.utility";
import { PopupUtility } from "./utilities/popup.utility";
import { TelerikUtility } from "./utilities/telerik.utility";
import { DocumentsUtility } from "./utilities/documents.utility";
import { QueriesUtility } from "./utilities/queries.utility";
import * as InitializationUtility from "./utilities/initialization.utility";
import { LoginUtility } from "./utilities/login.utility";
import { PartyUtility } from "./utilities/party.utility";
import * as CartUtility from "./utilities/cart.utility";
import * as SystemUtility from "./utilities/system.utility";
import * as GroupsUtility from "./utilities/groups.utility";
import * as IntegrationsUtility from "./utilities/integrations.utility";

declare global {
    namespace VAIMISUtilityV2 {
        namespace Models {
            const ImisAuthentication: typeof Authentication;
            const ImisMessageType: typeof MessageType;
            const ImisPayloadFieldType: typeof PayloadFieldType;
        }

        const General: typeof Helper;
        const Rest: typeof RestUtility;
        const Payload: typeof PayloadUtility;
        const Url: typeof UrlUtility;
        const GenTables: typeof GenTablesUtility;
        const DataSources: typeof DataSourcesUtility;
        const Html: typeof HtmlUtility;
        const Panels: typeof PanelsUtility;
        const Loader: typeof LoaderUtility;
        const Files: typeof FilesUtility;
        const Context: typeof ContextUtility;
        const WebForms: typeof WebFormsUtility;
        const Messages: typeof MessagesUtility;
        const Forms: typeof FormsUtility;
        const ChangeLog: typeof ChangeLogUtility;
        const iPart: typeof iPartUtility;
        const Popup: typeof PopupUtility;
        const Telerik: typeof TelerikUtility;
        const Documents: typeof DocumentsUtility;
        const Queries: typeof QueriesUtility;
        const Login: typeof LoginUtility;
        const Party: typeof PartyUtility;
        const Cart: typeof CartUtility;
        const System: typeof SystemUtility;
        const Groups: typeof GroupsUtility;
        const Integrations: typeof IntegrationsUtility;
    }

    interface Window {
        VAIMISUtilityV2: typeof VAIMISUtilityV2;
    }
}

namespace Models {
    export const ImisAuthentication = Authentication;
    export const ImisMessageType = MessageType;
    export const ImisPayloadFieldType = PayloadFieldType;
}

export {
    InitializationUtility as _internal,
    Models,
    Helper as General,
    RestUtility as Rest,
    PayloadUtility as Payload,
    UrlUtility as Url,
    GenTablesUtility as GenTables,
    DataSourcesUtility as DataSources,
    HtmlUtility as Html,
    PanelsUtility as Panels,
    LoaderUtility as Loader,
    FilesUtility as Files,
    ContextUtility as Context,
    WebFormsUtility as WebForms,
    MessagesUtility as Messages,
    FormsUtility as Forms,
    ChangeLogUtility as ChangeLog,
    iPartUtility as iPart,
    PopupUtility as Popup,
    TelerikUtility as Telerik,
    DocumentsUtility as Documents,
    QueriesUtility as Queries,
    LoginUtility as Login,
    PartyUtility as Party,
    CartUtility as Cart,
    SystemUtility as System,
    GroupsUtility as Groups,
    IntegrationsUtility as Integrations,
};
